import axiosInstance from "./AxiosInstance"

const API_URL = "/accessrequests"

// lms-api puts the specific reason ("Your role cannot request this access.")
// in errorStack and a generic {code, message} object in message; prefer the
// specific one, and never hand a raw object to a toast.
export const accessErrorMessage = (error, fallback = "Something went wrong. Please try again.") => {
  const data = error?.response?.data
  if (!data) return fallback
  if (typeof data.errorStack === "string" && data.errorStack.trim()) return data.errorStack
  const msg = data.message
  if (typeof msg === "string" && msg.trim()) return msg
  if (msg && typeof msg === "object" && typeof msg.message === "string") return msg.message
  return fallback
}

// What the signed-in user holds and what their roles may ask for. Worked out
// by the API from the session; `pending` marks a role already asked for.
export const getAccessOptions = async () => {
  const response = await axiosInstance.get(`${API_URL}/options`)
  return response.data?.data || { currentRoles: [], requestable: [] }
}

export const createAccessRequest = async ({ requestedRoleId, reason = "" }) => {
  const response = await axiosInstance.post(API_URL, { requestedRoleId, reason })
  return response.data?.data
}

// An administrator gets everyone's (status and search applied by the API);
// anyone else gets their own.
export const getAccessRequests = async ({ page = 1, limit = 10, status = "", search = "" } = {}) => {
  const params = { page, limit }
  if (status) params.status = status
  if (search && search.trim()) params.search = search.trim()
  const response = await axiosInstance.get(API_URL, { params })
  return {
    data: response.data?.data || [],
    pagination: response.data?.pagination,
    meta: response.data?.meta || {},
  }
}

export const approveAccessRequest = async (id) => {
  const response = await axiosInstance.put(`${API_URL}/${id}/approve`)
  return response.data?.data
}

export const rejectAccessRequest = async (id, reviewNote = "") => {
  const response = await axiosInstance.put(`${API_URL}/${id}/reject`, { reviewNote })
  return response.data?.data
}

export const cancelAccessRequest = async (id) => {
  const response = await axiosInstance.put(`${API_URL}/${id}/cancel`)
  return response.data?.data
}

// Every role and what it may ask for. Administrators only.
export const getAccessRules = async () => {
  const response = await axiosInstance.get(`${API_URL}/rules`)
  return response.data?.data || { roles: [] }
}

export const saveAccessRule = async (roleId, requestableRoleIds = []) => {
  const response = await axiosInstance.put(`${API_URL}/rules/${roleId}`, { requestableRoleIds })
  return response.data?.data
}
